import {AppVersion} from '../../types/AppVersion';

/**
 * Abstract base class for app filtering strategies.
 * Each filter type should extend this class and implement the matches method.
 *
 * @template T The type of the filter value (e.g., string, boolean, AppFeature)
 */
export abstract class AppFilterStrategy<T = any> {
  /**
   * Check if an app matches the current filter value.
   *
   * @param app The app to check
   * @param filterValue The current filter value (undefined means no filter applied)
   * @returns true if the app matches the filter criteria or if filter is not active
   */
  public abstract matches(app: AppVersion, filterValue: T | undefined): boolean;

  /**
   * Check if the filter is currently active (has a value set).
   *
   * @param filterValue The current filter value
   * @returns true if the filter has an active value
   */
  public isActive(filterValue: T | undefined): boolean {
    // Handle undefined, null, and empty strings
    if (filterValue === undefined || filterValue === null) {
      return false;
    }
    return true;
  }
}
